import React from 'react'

import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

type SiteBannerFieldsErrors = {
  siteBannerEnabled?: string
}

type SiteBannerFieldsProps = {
  enabled: boolean
  onChangeCallback: (update: { siteBannerEnabled: boolean }) => void
  errors?: SiteBannerFieldsErrors
}

const SiteBannerFields = ({ enabled, onChangeCallback, errors = {} }: SiteBannerFieldsProps) => {
  return (
    <FormSection title="Site Banner">
      <Checkbox
        label="Enabled"
        checked={enabled}
        onChange={() => onChangeCallback({ siteBannerEnabled: !enabled })}
        errorMessage={errors.siteBannerEnabled}
        listId="site-banner"
      />
    </FormSection>
  )
}

export default SiteBannerFields
